module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n	<span class="device-title '+
((__t=( obj.type ))==null?'':__t)+
'">'+
((__t=( name ))==null?'':__t)+
'</span>\n	<span class="m-status-indicator has-sign is-'+
((__t=( getConditionalStr(obj.online, 'positive', 'neutral') ))==null?'':__t)+
'">'+
((__t=( getConditionalStr(obj.online, 'online', 'offline') ))==null?'':__t)+
'</span>\n\n	<div class="device-details-items">\n		<div class="device-details-item">\n			<div class="device-details-item__inner">\n				<div class="name">S/N</div>\n				<div class="value">'+
((__t=( obj._id ))==null?'':__t)+
'</div>\n			</div>\n		</div>\n		<div class="device-details-item">\n			<div class="device-details-item__inner">\n				<div class="name">Type</div>\n				<div class="value">'+
((__t=( getDeviceTypeLabel() ))==null?'':__t)+
'</div>\n			</div>\n		</div>\n		<div class="device-details-item">\n			<div class="device-details-item__inner">\n				<div class="name">Firmware</div>\n				<div class="value">'+
((__t=( (obj.firmwareVersion) ? obj.firmwareVersion : '-' ))==null?'':__t)+
'</div>\n			</div>\n		</div>\n\n\n		<div class="device-details-item">\n			<div class="device-details-item__inner">\n				<div class="name">Gateway</div>\n				<div class="value">'+
((__t=( (obj.gateway) ? obj.gateway : '-' ))==null?'':__t)+
'</div>\n			</div>\n		</div>\n\n\n		';
 if (userHasRole ('super')) { 
__p+='\n\n			<div class="device-details-item">\n				<div class="device-details-item__inner">\n					<div class="name">Ip</div>\n					<div class="value">'+
((__t=( (obj.ip) ? obj.ip : '-' ))==null?'':__t)+
'</div>\n				</div>\n			</div>\n\n			<div class="device-details-item">\n				<div class="device-details-item__inner">\n					<div class="name">ICCID</div>\n					<div class="value">'+
((__t=( (obj.iccid) ? obj.iccid : '-' ))==null?'':__t)+
'</div>\n				</div>\n			</div>\n\n		';
 } 
__p+='\n\n	</div>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/devices/show/templates/headerDetails.html
// module id = 445
// module chunks = 0